import * as Actions from '../actions/actions-consts';
import { Action } from '../../definitions/types';
import { PRODUCT_TYPE_DOLPHIN, PRODUCT_TYPE_ONESTOP } from '../../modules/constants';

export interface Intent {
  industry: string;
  other: string;
  selectedProduct: string;
  preSelectedProduct: string;
  skipIndustryView: boolean;
  jumpToIndustryView: boolean;
  showWebsiteThreeMonthDiscountBadge: boolean;
}

// TODO cleanup GRW-1410
export type ValidProductType = 'dolphin' | 'creator' | 'onestop';

export const shouldSkipIndustryView = (state: Intent): boolean => {
  if (!state) {
    return false;
  }
  return state.skipIndustryView;
};

export const shouldjumpToIndustryView = (state: Intent): boolean => {
  if (!state) {
    return false;
  }

  return state.jumpToIndustryView;
};

export const shouldForwardToDolphinCms = (state: Intent): boolean => {
  if (!state) {
    return false;
  }

  return (
    state.selectedProduct === (PRODUCT_TYPE_DOLPHIN as ValidProductType) ||
    state.preSelectedProduct === (PRODUCT_TYPE_DOLPHIN as ValidProductType)
  );
};

// TODO cleanup GRW-1410
export const shouldForwardToOnestop = (state: Intent): boolean => {
  if (!state) {
    return false;
  }

  return (
    state.selectedProduct === (PRODUCT_TYPE_ONESTOP as ValidProductType) ||
    state.preSelectedProduct === (PRODUCT_TYPE_ONESTOP as ValidProductType)
  );
};

export const initialState = {
  industry: null as string,
  other: null as string,
  selectedProduct: null as string,
  preSelectedProduct: null as string,
  skipIndustryView: false,
  jumpToIndustryView: false,
  showWebsiteThreeMonthDiscountBadge: false,
};

export default function intent(state: Intent = initialState, action: Action<{}>): Intent {
  switch (action.type) {
    case Actions.SET_INDUSTRY:
      if (action.payload === state.industry) {
        return state;
      }
      return Object.assign({}, state, {
        industry: action.payload,
        other: null,
      });
    case Actions.SET_PRODUCT:
      if (action.payload === state.selectedProduct) {
        return state;
      }
      return Object.assign({}, state, { selectedProduct: action.payload });
    case Actions.SET_PRE_SELECTED_PRODUCT:
      if (action.payload === state.preSelectedProduct) {
        return state;
      }
      return Object.assign({}, state, { preSelectedProduct: action.payload });
    case Actions.SET_OTHER:
      if (action.payload === state.other) {
        return state;
      }
      return Object.assign({}, state, { other: action.payload });
    case Actions.SKIP_INDUSTRY_VIEW:
      if (state.skipIndustryView) {
        return state;
      }
      return Object.assign({}, state, { skipIndustryView: true });
    case Actions.SKIP_CATEGORY_VIEW:
      if (action.payload === state.jumpToIndustryView) {
        return state;
      }
      return Object.assign({}, state, { jumpToIndustryView: action.payload });
    case Actions.SHOW_THREE_MONTH_DISCOUNT_BADGE:
      if (state.showWebsiteThreeMonthDiscountBadge) {
        return state;
      }
      return Object.assign({}, state, {
        showWebsiteThreeMonthDiscountBadge: true,
      });
    default:
      return state;
  }
}
